export default "__VITE_ASSET__yqUETusY__"